import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Configuration} from '@shared/models/configuration';
import {take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {OtherDocument} from '@features/treaty/models/treaty.models';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-platform-tool-treaty-country-pair-selector',
  templateUrl: './platform-tool-treaty-country-pair-selector.component.html',
  styleUrls: ['./platform-tool-treaty-country-pair-selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolTreatyCountryPairSelectorComponent implements OnInit, IPlatformToolComponent {

  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  selectedCountry: any;
  otherDocuments: OtherDocument[];
  goToNextPageCommand: PlatformCommand;
  constructor(
    private httpClient: HttpClient,
    private fuseSplashScreenService: FuseSplashScreenService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    if (this.magicLinkModel?.tabBar?.tabs[0]?.tabData['CountryOne']) {
      this.selectedCountry = this.magicLinkModel.tabBar.tabs[0].tabData['CountryOne'];
    }
    this.goToNextPageCommand = this.getGoToNextPageCommand();
    this.fuseSplashScreenService.show();
    this.httpClient.get<any>(`${Configuration.getConfig('TreatyApi')}Treaty/OtherDocumentInfo`).pipe(take(1)).subscribe(
      data => {
        this.fuseSplashScreenService.hide();
        this.otherDocuments = data;
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Treaty Other Document Info Fetching Data error', error);
      }
    );
  }

  private getGoToNextPageCommand() {
    // For PlatformLink ActionMenu ViewLatestVersion
    if (this.magicLinkModel?.breadcrumbBar?.items) {
      const goToNextPageCommand = this.magicLinkModel?.breadcrumbBar?.items.find(
        item => item.id === 'Default')?.commands?.find(command => command.name === 'GoToNextPageCommand');
      return goToNextPageCommand;
    }
    return null;
  }
  onOtherDocumentClicked(otherDocument: OtherDocument) {
    let documentId = '';
    if (otherDocument?.navigation && otherDocument.navigation.length > 0) {
      for (const item of otherDocument.navigation) {
        if (item?.documentId) {
          documentId = item.documentId;
          break;
        }
      }
    }
    if (documentId) {
      window.open(`treaties/${documentId}`, '_blank');
    }
  }
  onCountryChange(countryInfo) {
    this.magicLinkModel.fieldValues['countryOne'] = countryInfo.countryOne.code;
    this.updateGoToNextPageCommand(countryInfo);
  }
  onCountryTwoChange(countryInfo) {
    this.magicLinkModel.fieldValues['countryTwo'] = countryInfo.countryTwo.code;
    this.updateGoToNextPageCommand(countryInfo);
  }
  updateGoToNextPageCommand(countryInfo) {
    if (this.goToNextPageCommand) {
      this.goToNextPageCommand.isDisabled = !(countryInfo?.countryOne && countryInfo?.countryTwo);
    }
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

}
